import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Trans } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import env from "../../env.json";
import ServiceTypeSelector from "../services/ServiceTypeSelector";

const { BASE_URL } = env;

function Navbar({ isSidebarOpen }) {
  const { firstname, lastname, role = "" } = JSON.parse(localStorage.getItem("admin"));
  const location = useLocation();

  const isTicketDashboard = location.pathname === "/tickets-dashboard";
  const isTicketAdmin = role === "ticket-admin";
  const isProduction = BASE_URL === "https://admin-api.cruze.asia";

  // Dynamic classes based on sidebar state
  const navbarMargin = isSidebarOpen ? "ml-[240px]" : "ml-[64px]";
  const navbarWidth = isSidebarOpen ? "w-[calc(100%-240px)]" : "w-[calc(100%-64px)]";

  // return (
  //   <nav className={`fixed top-0 right-0 ${navbarMargin} ${navbarWidth} bg-white shadow-sm z-50 transition-all duration-300`}>
  //     <div className={`flex items-center justify-between h-16 px-4 mx-auto ${isTicketAdmin ? 'max-w-full' : 'max-w-screen-2xl'}`}>

  //       {/* Admin Name - Centered */}
  //       {/* <div className="absolute left-1/2 transform -translate-x-1/2">
  //         <Link to="/" className="text-black no-underline hover:text-gray-700">
  //           <h1 className="text-lg font-semibold whitespace-nowrap">
  //             <Trans>{firstname} {lastname}</Trans>
  //           </h1>
  //         </Link>
  //       </div> */}


  //       <div className="w-full flex justify-between items-center px-4 py-2">
  //         <div className="flex items-center">
  //           <Link to="/" className="text-black no-underline hover:text-gray-700">
  //             <h1 className="text-lg font-semibold whitespace-nowrap">
  //               <Trans>{firstname} {lastname}</Trans>
  //             </h1>
  //           </Link>
  //         </div>
  //         {/* Add other navbar items here */}







  //         {/* Left spacer - balances layout */}
  //         <div className="flex-1"></div>

  //         {/* Right Content - Environment & Logout */}
  //         <div className="flex items-center space-x-4">
  //           {/* Environment Indicator */}
  //           <span className={`${isProduction ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'} font-bold py-1 px-2 rounded text-sm whitespace-nowrap`}>
  //             {isProduction ? <Trans>Production</Trans> : <Trans>Development</Trans>}
  //           </span>

  //           {/* Logout Button */}
  //           <Link
  //             to="/logout"
  //             onClick={() => localStorage.clear()}
  //             className="flex items-center text-black no-underline hover:text-gray-700"
  //           >
  //             <span className="hidden mr-1 text-sm font-medium sm:inline">
  //               <Trans>Logout</Trans>
  //             </span>
  //             <button className="p-1 rounded-full hover:bg-gray-100">
  //               <LogoutIcon className="text-current" />
  //             </button>
  //           </Link>



  //         </div>






  //       {/* Service Selector - Conditionally rendered */}
  //       {/* {!isTicketDashboard && !isTicketAdmin && (
  //         <div className="absolute left-1/3 transform -translate-x-1/2">
  //           <ServiceTypeSelector />
  //         </div>
  //       )} */}

  //         {/* Center Section - Conditionally render selector if not ticket admin/dashboard */}
  // {!isTicketDashboard && !isTicketAdmin && (
  //   <div className="flex justify-center w-full sm:w-auto">
  //     <ServiceTypeSelector />
  //   </div>
  // )}

  //       </div>



  //     </div>
  //   </nav>
  // );



  return (
    // <nav
    //   className={`fixed top-0 right-0 ${navbarMargin} ${navbarWidth} bg-white shadow-sm z-50 transition-all duration-300`}
    // >
    //   <div
    //     className={`flex flex-col sm:flex-row items-start sm:items-center justify-between px-4 py-2 mx-auto h-auto sm:h-16 ${
    //       isTicketAdmin ? 'max-w-full' : 'max-w-screen-2xl'
    //     }`}
    //   >
    //     {/* Left: Admin Name */}
    //     <div className="text-center mb-2 sm:mb-0">
    //       <Link
    //         to="/"
    //         className="text-black no-underline hover:text-gray-700"
    //       >
    //         <h1 className="text-base sm:text-lg font-semibold whitespace-nowrap">
    //           <Trans>{firstname} {lastname}</Trans>
    //         </h1>
    //       </Link>
    //     </div>




    //     {/* Center: Service Selector (conditionally) */}
    //     {!isTicketDashboard && !isTicketAdmin && (
    //       <div className="w-full sm:w-auto mb-2 sm:mb-0 flex justify-center">
    //         <ServiceTypeSelector />
    //       </div>
    //     )}

    //     {/* Right: Env & Logout */}
    //     <div className="flex items-center space-x-4 self-end sm:self-auto">
    //       {/* Environment Badge */}
    //       <span
    //         className={`${
    //           isProduction
    //             ? 'bg-green-100 text-green-800'
    //             : 'bg-blue-100 text-blue-800'
    //         } font-bold py-1 px-2 rounded text-xs sm:text-sm whitespace-nowrap`}
    //       >
    //         {isProduction ? <Trans>Production</Trans> : <Trans>Development</Trans>}
    //       </span>

    //       {/* Logout */}
    //       <Link
    //         to="/logout"
    //         onClick={() => localStorage.clear()}
    //         className="flex items-center text-black no-underline hover:text-gray-700"
    //       >
    //         <span className="hidden sm:inline mr-1 text-xs sm:text-sm font-medium">
    //           <Trans>Logout</Trans>
    //         </span>
    //         <button className="p-1 rounded-full hover:bg-gray-100">
    //           <LogoutIcon className="text-current w-4 h-4 sm:w-5 sm:h-5" />
    //         </button>
    //       </Link>
    //     </div>
    //   </div>
    // </nav>















    <nav
      className={`fixed top-0 right-0 ${navbarMargin} ${navbarWidth} bg-white shadow-sm z-50 transition-all duration-300`}
    >
      {/* <div
  
    className={`relative flex flex-col sm:flex-row items-start sm:items-center justify-between px-4 py-2 mx-auto h-auto sm:h-16 ${
      isTicketAdmin ? 'max-w-full' : 'max-w-screen-2xl'
    }`}
  > */}


      <div className={`relative flex flex-col sm:flex-row sm:items-center justify-start px-4 py-2 mx-auto h-auto sm:h-16 ${isTicketAdmin ? 'max-w-full' : 'max-w-screen-2xl'
        }`}>

        {/* Left placeholder on desktop only */}
        <div className="hidden sm:block sm:w-[120px]" />

        {/* Name: Centered on mobile in flow, absolutely centered on desktop */}
        <div className="block sm:hidden text-center w-full mb-2">
          <Link to="/" className="text-black no-underline hover:text-gray-700">
            <h1 className="text-base font-semibold whitespace-nowrap">
              <Trans>{firstname} {lastname}</Trans>
            </h1>
          </Link>
        </div>
        {/* <div className="hidden sm:block absolute left-1/2 transform -translate-x-1/2"> */}
        <div className="hidden sm:flex justify-center flex-1">

          <Link to="/" className="text-black no-underline hover:text-gray-700">
            <h1 className="text-lg font-semibold whitespace-nowrap">
              <Trans>{firstname} {lastname}</Trans>
            </h1>
          </Link>
        </div>

        {/* Service Selector: stays visible in both views */}
        {/* {!isTicketDashboard && !isTicketAdmin && (
          <div className="w-full sm:w-auto mb-2 sm:mb-0 flex justify-center">
            <ServiceTypeSelector />
          </div>
          
        )} */}

        {!isTicketDashboard && !isTicketAdmin && (
          <div className="w-full sm:w-auto mb-2 sm:mb-0 flex justify-center px-4">
            <ServiceTypeSelector />
          </div>
        )}


        {/* Right: Environment & Logout */}
        <div className="flex items-center space-x-5 self-end sm:self-auto">
          <span
            className={`${isProduction
              ? 'bg-green-100 text-green-800'
              : 'bg-blue-100 text-blue-800'
              } font-bold py-1 px-2 rounded text-xs sm:text-sm whitespace-nowrap mr-0 sm:mr-0`}
          >
            {isProduction ? <Trans>Production</Trans> : <Trans>Development</Trans>}
          </span>

          <Link
            to="/logout"
            onClick={() => localStorage.clear()}
            className="flex items-center text-black no-underline hover:text-gray-700"
          >
            <span className="hidden sm:inline mr-1 text-xs sm:text-sm font-medium">
              <Trans>Logout</Trans>
            </span>
            <button className="p-1 rounded-full hover:bg-gray-100">
              <LogoutIcon className="text-current w-4 h-4 sm:w-5 sm:h-5" />
            </button>
          </Link>
        </div>




        
      </div>
    </nav>


  );






}













export default Navbar;